import styled from '@emotion/styled';
import { Alert, colors, Typography } from '@ui-components/neo.tax';

export const StyledCsvConnectProvider = styled.div({
  maxWidth: 809,
});

export const InstructionsIntroText = styled(Typography)({
  marginTop: 24,
  marginBottom: 24,
  color: colors.gray[500],
});

export const InstructionsLink = styled.a({
  color: colors.primary[600],
  fontWeight: 600,
});

export const StyledAlert = styled(Alert)({
  marginTop: 24,
  marginBottom: 24,
});
